module.exports = __webpack_public_path__ + "static/DocuSign-86f31d71c538a98ac1efc7a9bcb3ebd1.jpg";